import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _component_OrganisationLinkingSearchInput = _resolveComponent("OrganisationLinkingSearchInput")!
  const _component_LinkedOrganisationsOverview = _resolveComponent("LinkedOrganisationsOverview")!
  const _component_ImportCampaignConfiguration = _resolveComponent("ImportCampaignConfiguration")!
  const _component_UnlinkOrganisationWarningModal = _resolveComponent("UnlinkOrganisationWarningModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorSubtitle'
		],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Link Organisations to this Campaign ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_OrganisationLinkingSearchInput),
    _createVNode(_component_LinkedOrganisationsOverview),
    _createVNode(_component_ImportCampaignConfiguration),
    (_ctx.isUnlinkOrganisationWarningActive)
      ? (_openBlock(), _createBlock(_component_UnlinkOrganisationWarningModal, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}